// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 777) return "static/js/recorder.1fab50a77.chunk.js";
	if (chunkId === 12) return "static/js/profiler.1fab50a77.chunk.js";
	if (chunkId === 31) return "static/js/31.1fab50a77.chunk.js";
	if (chunkId === 625) return "static/js/625.1fab50a77.chunk.js";
	if (chunkId === 160) return "static/js/160.1fab50a77.chunk.js";
	if (chunkId === 103) return "static/js/103.1fab50a77.chunk.js";
	if (chunkId === 177) return "static/js/177.1fab50a77.chunk.js";
	// return url for filenames based on template
	return undefined;
};